import api from '@/api'

export default{
    // 登录
    login(data) {
        return api({
            url: '/user/login',
            method: 'post',
            data
        })
    },
    // 注销
    logout() {
        return api({
            url: '/user/logout',
            method: 'post',
        })
    }
} 
